export const pl = {
  // Navigation
  navigation: {
    singleVerification: 'Weryfikacja Pojedyncza',
    batchVerification: 'Weryfikacja Grupowa',
    about: 'O Aplikacji',
    logout: 'Wyloguj'
  },
  auth: {
    emailVerification: {
      title: 'Zweryfikuj Swój Email',
      message: 'Wysłaliśmy email weryfikacyjny na adres {email}. Sprawdź swoją skrzynkę odbiorczą i kliknij link weryfikacyjny, aby aktywować konto.',
      checkEmail: 'Sprawdź swój email',
      followInstructions: 'Postępuj zgodnie z instrukcjami w emailu, aby zweryfikować konto.',
      resendEmail: 'Wyślij Ponownie Email Weryfikacyjny',
      sending: 'Wysyłanie...',
      backToLogin: 'Powrót do Logowania',
      emailSent: 'Email weryfikacyjny został wysłany pomyślnie!',
      helpText: 'Jeśli nie widzisz emaila w skrzynce odbiorczej, sprawdź folder spam.'
    }
  },

  // Header
  header: {
    title: 'Weryfikacja VAT Peppol',
    subtitle: 'Narzędzie Weryfikacji VAT UE & Peppol'
  },

  // Footer
  footer: {
    description: 'Narzędzie Weryfikacji VAT Peppol - Zbudowane z React & TypeScript',
    disclaimer: 'Tylko do celów demonstracyjnych. Użycie produkcyjne wymaga właściwej integracji API.',
    termsOfUse: 'Warunki Użytkowania',
    privacyPolicy: 'Polityka Prywatności'
  },

  // About Page
  about: {
    title: 'O Weryfikacji VAT Peppol',
    overview: {
      title: 'Przegląd',
      content: 'Ta aplikacja zapewnia usługi weryfikacji numerów VAT UE i identyfikatorów uczestników Peppol. Obsługuje zarówno weryfikację pojedynczych firm, jak i przetwarzanie wsadowe dla wielu wpisów.'
    },
    features: {
      title: 'Funkcje',
      items: [
        { label: 'Weryfikacja VAT UE:', description: 'Waliduj numery VAT używając systemu VIES (System Wymiany Informacji o VAT)' },
        { label: 'Weryfikacja Peppol:', description: 'Sprawdź identyfikatory uczestników w katalogu Peppol' },
        { label: 'Weryfikacja Podwójna:', description: 'Uruchom zarówno weryfikację VAT jak i Peppol z jednym identyfikatorem' },
        { label: 'Weryfikacja Pojedyncza:', description: 'Weryfikuj pojedyncze firmy ze szczegółowymi wynikami' },
        { label: 'Przetwarzanie Wsadowe:', description: 'Przesyłaj pliki CSV do weryfikacji masowej' },
        { label: 'Integracja Prawdziwego API:', description: 'Przełączaj między prawdziwymi wywołaniami API a trybem symulacji' },
        { label: 'Eksport Wyników:', description: 'Pobierz wyniki weryfikacji jako pliki CSV' },
        { label: 'Pobieranie Szablonów:', description: 'Uzyskaj szablony CSV dla właściwego formatowania danych' }
      ]
    },
    vatFormats: {
      title: 'Obsługiwane Formaty Numerów VAT',
      description: 'Aplikacja obsługuje numery VAT ze wszystkich państw członkowskich UE:',
      examples: [
        'Austria: U12345678',
        'Belgia: 1234567890',
        'Niemcy: 123456789',
        'Francja: AB123456789',
        'Włochy: 12345678901',
        'Holandia: 123456789B01',
        'Hiszpania: A12345678',
        'I wiele więcej...'
      ]
    },
    peppolTypes: {
      title: 'Typy Identyfikatorów Uczestników Peppol',
      items: [
        { type: 'DUNS:', description: '9-cyfrowy Uniwersalny System Numeracji Danych' },
        { type: 'GLN:', description: '12-15-cyfrowy Globalny Numer Lokalizacji' },
        { type: 'VAT:', description: 'Kod kraju + numer VAT' },
        { type: 'Niestandardowy:', description: 'Identyfikatory specyficzne dla organizacji' }
      ]
    },
    apiMode: {
      title: 'Przełącznik Trybu API',
      description: 'Aplikacja zawiera przełącznik do wyboru między:',
      items: [
        { mode: 'Tryb Symulacji:', description: 'Używa danych testowych do celów demonstracyjnych' },
        { mode: 'Tryb Prawdziwego API:', description: 'Wykonuje prawdziwe wywołania do API VIES i Peppol' }
      ]
    },
    importantNotes: {
      title: 'Ważne Uwagi',
      items: [
        'Tryb prawdziwego API wymaga właściwego dostępu sieciowego do usług VIES i Peppol',
        'Niektóre API mogą mieć ograniczenia szybkości lub wymagać uwierzytelnienia',
        'Tryb symulacji jest zalecany do testowania i demonstracji',
        'Użycie produkcyjne powinno zawierać właściwą obsługę błędów i logikę ponawiania'
      ]
    },
    technicalDetails: {
      title: 'Szczegóły Techniczne',
      content: 'Zbudowane z React, TypeScript i Tailwind CSS. Używa Papa Parse do przetwarzania CSV i zawiera kompleksową obsługę błędów i informacje zwrotne użytkownika.'
    }
  },

  // Terms of Use
  termsOfUse: {
    title: 'Warunki Użytkowania – vateu.eu',
    sections: {
      scope: {
        title: '1. Zakres i Status Beta',
        content: 'Usługa jest świadczona bezpłatnie wyłącznie do celów oceny. Jest obecnie oferowana wybranym testerom, w tym Shell, w celu oceny jakości i skuteczności przed potencjalną komercyjną publikacją. Nie zaleca się używania w środowisku produkcyjnym. Usługa może być modyfikowana, zawieszana lub przerywana w dowolnym momencie bez powiadomienia.'
      },
      dataSources: {
        title: '2. Źródła Danych',
        content: 'Walidacje VAT są wykonywane przy użyciu systemu VIES Komisji Europejskiej i połączonych krajowych baz danych. Walidacje Peppol są oparte na publicznych źródłach Katalogu Peppol / SMP. Nie jesteśmy powiązani z Komisją Europejską, żadną krajową władzą podatkową ani OpenPeppol.'
      },
      accuracy: {
        title: '3. Dokładność i Dostępność',
        content: 'Informacje mogą być opóźnione, niekompletne lub niedostępne z powodu awarii systemów stron trzecich. Usługa jest świadczona "jak jest", bez żadnych gwarancji. Żadne prawa lub obowiązki nie mogą wynikać z wyników walidacji.'
      },
      acceptableUse: {
        title: '4. Dopuszczalne Użycie',
        content: 'Użytkownicy nie mogą nadużywać Usługi przez nadmierne zautomatyzowane żądania. Zapytania grupowe podlegają ograniczeniom szybkości i mogą być zablokowane. Usługa nie może być używana do celów nielegalnych.'
      },
      intellectualProperty: {
        title: '5. Własność Intelektualna',
        content: 'Treść, kod i projekt vateu.eu należą do Mariusza Pietruszki (PL6572490600). "VIES" i "Peppol" to nazwy stron trzecich; nie rościmy sobie praw do nich i używamy ich tylko opisowo. Nie używaj emblematu UE ani logo Peppol w związku z tą Usługą.'
      },
      privacy: {
        title: '6. Prywatność i Obsługa Danych',
        content: 'Usługa nie przechowuje na stałe numerów VAT, identyfikatorów Peppol ani wyników walidacji przesłanych przez użytkowników. Dane wejściowe są przekazywane tylko do odpowiednich systemów walidacji stron trzecich (np. VIES, Katalog Peppol) i przetwarzane wyłącznie w celu wygenerowania wyniku walidacji wyświetlanego Tobie. Po zwróceniu wyniku żadna kopia danych wejściowych ani wyniku walidacji nie jest zachowywana w naszym systemie, z wyjątkiem krótkoterminowych dzienników technicznych (patrz Polityka Prywatności).'
      },
      liability: {
        title: '7. Odpowiedzialność',
        content: 'W najszerszym zakresie dozwolonym przez prawo, wykluczamy wszelkie gwarancje, wyraźne lub dorozumiane. Nie przyjmujemy odpowiedzialności za szkody bezpośrednie, pośrednie lub wynikowe wynikające z używania Usługi.'
      },
      changes: {
        title: '8. Zmiany',
        content: 'Możemy aktualizować te Warunki w dowolnym momencie. Kontynuowanie używania oznacza akceptację zrewidowanych Warunków.'
      },
      governingLaw: {
        title: '9. Prawo Właściwe',
        content: 'Te Warunki są regulowane przez prawo Polski. Wszelkie spory podlegają wyłącznej jurysdykcji sądów Polski.',
        contact: 'Kontakt: Mariusz Pietruszka – PL6572490600'
      }
    }
  },

  // Privacy Policy
  privacyPolicy: {
    title: 'Polityka Prywatności – vateu.eu',
    effectiveDate: 'Data wejścia w życie: 14/09/2025',
    sections: {
      controller: {
        title: '1. Administrator',
        content: 'Usługa jest prowadzona przez: [Nazwa Twojej firmy, zarejestrowany adres, email kontaktowy] W sprawach prywatności, kontakt: [privacy@vateu.eu].'
      },
      dataWeProcess: {
        title: '2. Dane, Które Przetwarzamy',
        inputData: 'Dane wejściowe: numery VAT i identyfikatory Peppol, które przesyłasz do walidacji, są przetwarzane tylko w pamięci i przekazywane do VIES lub Katalogu Peppol. Nie przechowujemy tych identyfikatorów ani wyników walidacji.',
        logs: 'Dzienniki: minimalne dane techniczne (adres IP, typ przeglądarki, znacznik czasu, dzienniki błędów) mogą być zbierane w celu zapewnienia bezpieczeństwa i rozwiązywania problemów.',
        optionalContact: 'Opcjonalny kontakt: jeśli skontaktujesz się z nami przez email lub formularz, przetwarzamy Twoje dane kontaktowe i wiadomość.'
      },
      purposeAndLegalBasis: {
        title: '3. Cel i Podstawa Prawna',
        items: [
          'Aby zapewnić wyniki walidacji (nasz uzasadniony interes, Art. 6(1)(f) RODO).',
          'Aby zapobiec nadużyciom i zapewnić stabilność systemu (uzasadniony interes).',
          'Aby komunikować się z Tobą, jeśli się z nami skontaktujesz (wykonanie umowy, Art. 6(1)(b) RODO).'
        ]
      },
      dataRetention: {
        title: '4. Przechowywanie Danych',
        items: [
          'Identyfikatory VAT/Peppol i wyniki walidacji nie są przechowywane po zakończeniu żądania walidacji.',
          'Dzienniki są przechowywane maksymalnie przez [np. 30 dni], a następnie usuwane lub anonimizowane.',
          'Dane kontaktowe są przechowywane tak długo, jak to konieczne do odpowiedzi na Twoje żądanie.'
        ]
      },
      dataSharing: {
        title: '5. Udostępnianie Danych',
        items: [
          'Żądania walidacji są przekazywane do systemów VIES (Komisja Europejska) i/lub Katalogu Peppol.',
          'Nie sprzedajemy ani nie udostępniamy danych osobowych stronom trzecim w celach marketingowych.',
          'Dostawcy hostingu i infrastruktury mogą przetwarzać dane w naszym imieniu na podstawie umów o przetwarzanie danych.'
        ]
      },
      internationalTransfers: {
        title: '6. Transfery Międzynarodowe',
        content: 'Dane mogą być przetwarzane na serwerach zlokalizowanych w UE/EOG. Jeśli dochodzi do transferów poza UE/EOG, zapewniamy odpowiednie zabezpieczenia (np. Standardowe Klauzule Umowne).'
      },
      yourRights: {
        title: '7. Twoje Prawa',
        description: 'Masz prawa zgodnie z RODO, w tym:',
        items: [
          'Dostęp do swoich danych',
          'Sprawdzenie lub usunięcie',
          'Ograniczenie lub sprzeciw wobec przetwarzania',
          'Przenoszenie danych',
          'Złożenie skargi do organu nadzorczego'
        ]
      },
      cookiesAnalytics: {
        title: '8. Pliki Cookie i Analityka',
        content: 'Używamy tylko niezbędnych plików cookie do funkcjonalności usługi. Jeśli wprowadzimy analitykę lub niezbędne pliki cookie, poprosimy o zgodę.'
      },
      changes: {
        title: '9. Zmiany',
        content: 'Możemy aktualizować tę Politykę Prywatności. Najnowsza wersja będzie zawsze dostępna na stronie.'
      },
      contact: {
        title: '10. Kontakt',
        content: 'W sprawach pytań lub żądań dotyczących tej Polityki Prywatności, napisz na [privacy@vateu.eu].'
      }
    }
  },

  // Single Verification
  singleVerification: {
    title: 'Weryfikacja Pojedyncza',
    verificationType: 'Typ Weryfikacji',
    types: {
      vat: 'Weryfikacja VAT UE',
      peppol: 'Weryfikacja Peppol',
      both: 'Obie Weryfikacje'
    },
    forms: {
      vatNumber: 'Numer VAT',
      vatNumberPlaceholder: 'np. PL1234567890',
      peppolId: 'ID Uczestnika Peppol',
      peppolIdPlaceholder: 'np. 123456789 (DUNS) lub 1234567890123 (GLN)',
      peppolIdHelp: 'Wprowadź numer DUNS, GLN, numer VAT, lub niestandardowy identyfikator uczestnika',
      companyIdentifier: 'Identyfikator Firmy',
      companyIdentifierPlaceholder: 'np. PL1234567890, 123456789, lub 1234567890123',
      companyIdentifierHelp: 'Wprowadź numer VAT (PL1234567890), DUNS (123456789), GLN (1234567890123), lub inny identyfikator',
      unifiedTitle: 'Weryfikacja Ujednolicona',
      unifiedDescription: 'Wprowadź pojedynczy identyfikator, który będzie używany do weryfikacji VAT i Peppol. Może to być numer VAT, DUNS, GLN, lub inny identyfikator firmy.'
    },
    buttons: {
      verify: 'Weryfikuj',
      verifying: 'Weryfikacja...',
      reset: 'Resetuj'
    },
    apiMode: {
      simulationMode: 'Tryb Symulacji',
      realAPI: 'Prawdziwe API',
      simulation: 'Symulacja'
    },
    results: {
      verificationSuccessful: 'Weryfikacja Pomyślna',
      verificationFailed: 'Weryfikacja Nieudana',
      verificationResults: 'Wyniki Weryfikacji',
      vatVerification: 'Weryfikacja VAT',
      peppolVerification: 'Weryfikacja Peppol',
      fields: {
        vatNumber: 'Numer VAT',
        companyName: 'Nazwa Firmy',
        address: 'Adres',
        fullParticipantId: 'Pełny ID Uczestnika',
        participantName: 'Nazwa Uczestnika',
        participantId: 'ID Uczestnika',
        scheme: 'Schemat',
        supportedDocumentTypes: 'Obsługiwane Typy Dokumentów',
        supportsBilling: 'Obsługuje Fakturowanie',
        error: 'Błąd',
        verifiedAt: 'Zweryfikowano o',
        yes: 'Tak',
        no: 'Nie'
      },
      multipleMatches: {
        title: 'Znaleziono Wiele Dopasowań',
        matchCount: 'dopasowania',
        match: 'Dopasowanie'
      }
    }
  },

  // Batch Verification
  batchVerification: {
    title: 'Weryfikacja Grupowa',
    inputMethod: 'Metoda Wprowadzania',
    methods: {
      csv: 'Przesyłanie CSV',
      textarea: 'Wprowadzanie Tekstu'
    },
    forms: {
      uploadFile: 'Prześlij Plik CSV',
      downloadTemplate: 'Pobierz Szablon CSV',
      textAreaPlaceholder: 'Wprowadź identyfikatory oddzielone przecinkami lub nowymi liniami (np. PL1234567890, 123456789, 1234567890123)',
      textAreaHelp: 'Wprowadź jeden lub więcej identyfikatorów na linię. Oddziel kilka identyfikatorów w tej samej linii przecinkami.',
      textInputTitle: 'Dla wprowadzania tekstu, wprowadź identyfikatory oddzielone przecinkami:',
      textInputDescription: 'Wprowadź identyfikatory oddzielone przecinkami. Każda linia może zawierać wiele identyfikatorów. Obsługuje numery VAT, DUNS, GLN i inne identyfikatory firm.',
      textInputRules: [
        'Każda linia może zawierać wiele identyfikatorów oddzielonych przecinkami',
        'Obsługuje numery VAT (PL1234567890), DUNS (123456789), GLN (1234567890123)',
        'Puste linie są ignorowane',
        'Spacje wokół identyfikatorów są automatycznie usuwane'
      ],
      dualVerificationHelp: 'Identyfikator może być numerem VAT, DUNS, GLN lub innym identyfikatorem firmy, który działa dla weryfikacji VAT i Peppol.',
      identifiersReady: 'identyfikatory gotowe do weryfikacji',
      exportResults: 'Eksportuj wyniki',
      textInputPlaceholder: 'Wprowadź identyfikatory oddzielone przecinkami. Każda linia może zawierać wiele identyfikatorów:\n\nPL1234567890, DE123456789\n123456789, 987654321\n1234567890123',
      textInputHelp: 'Wprowadź identyfikatory oddzielone przecinkami. Każda linia może zawierać wiele identyfikatorów. Obsługuje numery VAT, DUNS, GLN i inne identyfikatory firm.'
    },
    buttons: {
      process: 'Przetwórz Weryfikację',
      processing: 'Przetwarzanie...',
      downloadResults: 'Pobierz Wyniki',
      reset: 'Resetuj',
      cancel: 'Anuluj'
    },
    results: {
      summary: 'Podsumowanie Weryfikacji',
      totalProcessed: 'Łącznie Przetworzono',
      valid: 'Prawidłowe',
      invalid: 'Nieprawidłowe',
      errors: 'Błędy',
      processingTime: 'Czas Przetwarzania',
      noResults: 'Brak wyników do wyświetlenia',
      exportResults: 'Eksportuj Wyniki',
      vatVerification: 'Weryfikacja VAT',
      dualVerificationResults: 'Wyniki Podwójnej Weryfikacji'
    },
    progress: {
      processing: 'Przetwarzanie weryfikacji...',
      completed: 'Przetwarzanie zakończone'
    },
    format: {
      csvRequirements: 'Wymagania Format CSV',
      textInputFormat: 'Format Wprowadzania Tekstu',
      dualVerificationTitle: 'Dla podwójnej weryfikacji, dodaj te kolumny:',
      dualVerificationColumns: [
        'identifier lub id - Identyfikator firmy (wymagane)',
        'Alternatywne nazwy kolumn: vatNumber, vat, taxId, participantId, peppolId'
      ],
      vatVerificationTitle: 'Dla weryfikacji VAT, dodaj te kolumny:',
      vatVerificationColumns: [
        'vatNumber lub vat lub taxId - Numer VAT (wymagane)'
      ],
      peppolVerificationTitle: 'Dla weryfikacji Peppol, dodaj te kolumny:',
      peppolVerificationColumns: [
        'participantId lub peppolId lub id - ID Uczestnika (wymagane)'
      ]
    }
  },

  // Error Messages
  errors: {
    general: {
      unknownError: 'Wystąpił nieznany błąd',
      networkError: 'Wystąpił błąd sieci',
      parsingError: 'Błąd podczas analizowania pliku CSV. Sprawdź format.',
      noDataToProcess: 'Prześlij plik CSV lub wprowadź identyfikatory w obszarze tekstu.',
      invalidInput: 'Podano nieprawidłowe dane wejściowe'
    },
    vat: {
      invalidFormat: 'Nieprawidłowy format numeru VAT',
      countryNotSupported: 'Kraj nie jest obsługiwany przez VIES',
      serviceUnavailable: 'Usługa VIES jest obecnie niedostępna',
      timeout: 'Przekroczono limit czasu - usługa VIES może być wolna',
      rateLimit: 'Przekroczono limit szybkości - spróbuj ponownie później'
    },
    peppol: {
      invalidFormat: 'Nieprawidłowy format ID uczestnika Peppol',
      serviceUnavailable: 'Usługa Peppol jest obecnie niedostępna',
      timeout: 'Przekroczono limit czasu - usługa Peppol może być wolna',
      notFound: 'Uczestnik nie został znaleziony w katalogu Peppol',
      rateLimit: 'Przekroczono limit szybkości - spróbuj ponownie później'
    },
    serviceUnavailable: {
      title: 'Usługa Niedostępna',
      message: 'Usługa {service} jest obecnie niedostępna z powodu dużego obciążenia lub konserwacji. Automatycznie ponowimy Twoje żądanie.',
      autoRetryIn: 'Automatyczna ponowna próba za:',
      retryNow: 'Spróbuj Ponownie Teraz',
      cancel: 'Anuluj',
      helpText: 'Możesz spróbować ponownie ręcznie lub poczekać na automatyczną ponowną próbę. Usługa zostanie przywrócona tak szybko, jak to możliwe.'
    }
  }
};
